export var CustomerStatus;
(function (CustomerStatus) {
    CustomerStatus["Active"] = "ACTIVE";
    CustomerStatus["Pending"] = "PENDING";
    CustomerStatus["Disabled"] = "DISABLED";
})(CustomerStatus || (CustomerStatus = {}));
